
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Layout } from '../components/Layout/Layout';
import Home from '../components/Home/Home';
import ThankYou from '../components/ThankYou/ThankYou';
import Fcontact from '../components/Shared/Fcontact';
import Insights from '../components/Insights/Insights';
import Blogs from '../components/Insights/Blogs/Blogs';
import NonprofitFundraisingSuccess from '../components/Insights/Blogs/Blog-Details/NonprofitFundraisingSuccess';
import DonorManagementForNonprofits from '../components/Insights/Blogs/Blog-Details/DonorManagementForNonprofits';
import TheGrantLifecycle from '../components/Insights/Blogs/Blog-Details/TheGrantLifecycle';
import CaseStudy from '../components/Insights/CaseStudy/CaseStudy';
import EBook from '../components/Insights/eBook/eBook';
import Webinar from '../components/Insights/Webinar/Webinar';
import Packages from '../components/Packages/Packages';
import ContactUs from '../components/ContactUs/ContactUs';
import PricingPlan from '../components/PricingPlan/PricingPlan';
import Integrations from '../components/Integrations/Integrations';
import GrantsManagement from '../components/Solutions/GrantManagement/GrantsManagement';
import DonationManagement from '../components/Solutions/DonationManagement/DonationManagement';

const AllRoutes = () => {
  return (
    <Layout>
      <Routes>
        <Route path='/' element={<Home />}></Route>
        <Route path='/solutions/grants-management-solution' element={<GrantsManagement />}></Route>
        <Route path='/solutions/donation-management-system' element={<DonationManagement />}></Route>
        <Route path='/packages' element={<Packages />}></Route>
        <Route path='/pricing-plan' element={<PricingPlan />}></Route>
        <Route path='/integrations' element={<Integrations />}></Route>
        <Route path='/contact-us' element={<ContactUs />}></Route>
        <Route path='/thank-you' element={<ThankYou />}></Route>
        <Route path='/insights' element={<Insights />}></Route>
        {/* <Route path='/insights/blogs' element={<Insights />}></Route> */}
        {/* <Route path='/insights/case-study' element={<Insights />}></Route> */}
        {/* <Route path='/insights/eBook' element={<Insights />}></Route> */}
        {/* <Route path='/insights/video' element={<Insights />}></Route> */}
        {/* <Route path='/insights/webinar' element={<Insights />}></Route> */}
        {/* <Route path='/insights/blogs' element={<Blogs />}></Route>
        <Route path='/insights/case-study' element={<CaseStudy />}></Route>
        <Route path='/insights/eBook' element={<EBook />}></Route>
        <Route path='/insights/webinar' element={<Webinar />}></Route> */}
        <Route path='/blog/nonprofit-fundraising' element={<NonprofitFundraisingSuccess />}></Route>
        <Route path='/blog/donor-management-for-nonprofits' element={<DonorManagementForNonprofits />}></Route>
        <Route path='/blog/the-grant-lifecycle' element={<TheGrantLifecycle />}></Route>
      </Routes>
    </Layout>
  )
}

export default AllRoutes
